/* ------------------------------------------------------------------
   خروج از گفتگو همراهِ خروج از پنل
   ------------------------------------------------------------------
   🔴 Rocket.Chat جلسهٔ خودش را جدا از پنل در مرورگر نگه می‌دارد.
   خروج از پنل آن را نمی‌بست؛ نفرِ بعدی که در همان مرورگر وارد پنل
   می‌شد، گفتگوی نفرِ قبلی را می‌دید (دیده‌شده ۲۰۲۶-۱۰-۰۴).

   قابِ گفتگو هنگامِ ساخته‌شدن یک «خروج» اینجا ثبت می‌کند و
   `AuthProvider` پیش از خروج از پنل صدایش می‌زند.

   ⚠️ اگر قاب هرگز ساخته نشده باشد کاری نمی‌کند — جلسهٔ Rocket.Chat
   در مرورگر می‌ماند. آن حالت را بررسیِ هویت در `ChatFrameHost` در
   ورودِ بعدی می‌گیرد؛ این فقط آن را زودتر می‌بندد.
   ------------------------------------------------------------------ */

type SignOut = () => Promise<void>

let current: SignOut | null = null

export function registerChatSignOut(signOut: SignOut): () => void {
  current = signOut
  return () => {
    if (current === signOut) current = null
  }
}

export const CHAT_ATTEMPTS_KEY = 'pf-chat-sso-attempts'

export async function signOutOfChat(): Promise<void> {
  /*
    ⚠️ شمارندهٔ تلاشِ ورود در sessionStorage ِ همین زبانه است. اگر
    پاک نشود، کاربرِ بعدی در همین زبانه ممکن است به سقف رسیده باشد و
    ورودِ خودکارش اصلاً شروع نشود.
  */
  try {
    sessionStorage.removeItem(CHAT_ATTEMPTS_KEY)
  } catch {
    /* بی‌اثر */
  }

  if (!current) return

  try {
    await current()
  } catch {
    /* خروج از پنل نباید به‌خاطرِ گفتگو گیر کند. */
  }
}
